import type { Result } from '@schibsted-nmp/search-frontend-clients/suggest';
import React from 'react';
import { SearchboxMatch } from '../searchbox/SearchboxMatch';

type ResultTitleProps = {
    result: Result;
};

export function ResultTitle(props: ResultTitleProps) {
    const { result } = props;

    const title = result.secondaryTitle
        ? [result.title, result.secondaryTitle].join(' - ')
        : result.title;

    return (
        <span>
            <SearchboxMatch value={title} query={result.originalQuery} />
        </span>
    );
}
